import React, { useContext, useState } from 'react';

import PersonAvatar from 'app/components/CommonStyled/PersonAvatar';
import GlobalPersonDrawer from 'app/components/Drawers/GlobalPerson/GlobalPersonDrawer';
import { contributorRoleLabel } from 'app/components/ResourceSubmission/contributorPresentation';
import useIsMobile from 'hooks/useIsMobile';
import { singularOrPlural } from 'utils';

import { ResourceDetailContext } from '../ResourceDetailContext';
import { ResourceSubtitle } from '../styled';
import {
  ResourceDetailTeamPersonWrapper,
  ResourceDetailTeamPersonName,
  ResourceDetailTeamPersonRole,
  ResourceDetailTeamWrapper,
  ResourceDetailTeamPersonInformationContainer,
  ResourceDetailTeamShowMoreCircle,
  ResourceDetailTeamShowMoreText,
  ResourceDetailTeamTitleContainer,
} from './styled';

const SideDrawer = React.lazy(() => import('app/components/CommonStyled/SideDrawer'));

export default function ResourceDetailTeam() {
  const isMobile = useIsMobile();
  const [currentlyShowing, setCurrentlyShowing] = useState<number>(isMobile ? 2 : 4);
  const [drawer, setDrawer] = useState<{ show: boolean; slug: string }>({ show: false, slug: '' });
  const { data } = useContext(ResourceDetailContext);

  const handlePersonClick = (slug: string) => {
    setDrawer({ show: true, slug });
  };

  const handleShowMore = () => {
    setCurrentlyShowing(currentlyShowing + 5);
  };

  return (
    <>
      <ResourceDetailTeamTitleContainer>
        <ResourceSubtitle>THE TEAM</ResourceSubtitle>
      </ResourceDetailTeamTitleContainer>
      <ResourceDetailTeamWrapper>
        {data?.contributors?.people?.slice(0, currentlyShowing).map((person) => (
          <ResourceDetailTeamPersonWrapper
            key={person.slug}
            onClick={() => handlePersonClick(person.slug)}
          >
            <PersonAvatar
              size={40}
              avatar={person.avatar}
              name={person.name}
              lastName={person.name.split(' ')[1]}
              highlighted
              disablePropagation
              onClick={() => {}}
            />
            <ResourceDetailTeamPersonInformationContainer>
              <ResourceDetailTeamPersonName>{person.name}</ResourceDetailTeamPersonName>
              <ResourceDetailTeamPersonRole>
                {contributorRoleLabel(person)}
              </ResourceDetailTeamPersonRole>
            </ResourceDetailTeamPersonInformationContainer>
          </ResourceDetailTeamPersonWrapper>
        ))}
        {data?.contributors?.people?.length > currentlyShowing ? (
          <ResourceDetailTeamPersonWrapper onClick={handleShowMore} style={{ cursor: 'pointer' }}>
            <ResourceDetailTeamShowMoreCircle>
              <ResourceDetailTeamShowMoreText>
                +{data.contributors.people.length - currentlyShowing}
              </ResourceDetailTeamShowMoreText>
            </ResourceDetailTeamShowMoreCircle>
            <ResourceDetailTeamPersonInformationContainer>
              <ResourceDetailTeamPersonName>
                and {data.contributors.people.length - currentlyShowing}{' '}
                {singularOrPlural(
                  data.contributors.people.length - currentlyShowing,
                  'other',
                  'others'
                )}
              </ResourceDetailTeamPersonName>
              <ResourceDetailTeamPersonRole>VIEW</ResourceDetailTeamPersonRole>
            </ResourceDetailTeamPersonInformationContainer>
          </ResourceDetailTeamPersonWrapper>
        ) : null}
        {drawer.show ? (
          <SideDrawer closeDrawer={() => setDrawer({ show: false, slug: '' })} withClose>
            <GlobalPersonDrawer slug={drawer.slug} />
          </SideDrawer>
        ) : null}
      </ResourceDetailTeamWrapper>
    </>
  );
}
